import { XCircleIcon } from "@heroicons/react/20/solid";
import React, {useEffect, useState} from "react";
import { Form, Link, useActionData, useNavigate } from "react-router-dom";
import AuthenticationResponse from "../../models/interfaces/authentication-response";
import BaamerLogo from "/images/tgmlogos/logo.png";
import useAuthenticationContext from "../../services/context/authentication/use-authentication-context.ts";

const SignInPage: React.FC = () => {
    const data = useActionData() as AuthenticationResponse & {
        message?: string;
    };
    
    const { setAuthenticationResponse } = useAuthenticationContext();
    const navigate = useNavigate();
    const [isPending, setIsPending] = useState<boolean>(false);

    useEffect(() => {
        if (data?.token != null || data?.message != null) {
            setIsPending(false);
        }
    }, [data]);

    useEffect(() => {
        if (data?.token != null) {
            setAuthenticationResponse(data);
            navigate("/projects");
        }
    }, [setAuthenticationResponse, data, navigate]);
    
    return (
        <div className="flex flex-col justify-center flex-1 min-h-full py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <Link to="/">
                    <img
                        className="w-auto h-10 mx-auto"
                        src={BaamerLogo}
                        alt="Treegram"
                    />
                </Link>
                <h2 className="mt-6 text-2xl font-bold leading-9 tracking-tight text-center text-gray-900">
                    Se connecter à votre compte
                </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                {data?.message != null && (
                    <div className="p-4 mb-4 rounded-md shadow-sm bg-red-50">
                        <div className="flex">
                            <div className="shrink-0">
                                <XCircleIcon
                                    className="w-5 h-5 text-red-400"
                                    aria-hidden="true"
                                />
                            </div>
                            <div className="ml-3">
                                <h3 className="text-sm font-medium text-red-800">
                                    {data.message ||
                                        "Echec de l'authentification, les identifiants entrées n'ont pas été reconnues."}
                                </h3>
                            </div>
                        </div>
                    </div>
                )}
                <div className="px-6 py-12 bg-white shadow-sm sm:rounded-lg sm:px-12">
                    <Form
                        onSubmit={() => {
                            setIsPending(true)
                        }}
                        className="space-y-6"
                        method="POST"
                    >
                        <div>
                            <label
                                htmlFor="email"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                Courriel
                            </label>
                            <div className="mt-2">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <label
                                htmlFor="password"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                Mot de passe
                            </label>
                            <div className="mt-2">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete="current-password"
                                    required
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        
                        <div>
                            <button
                                type="submit" disabled={isPending}
                                className={`flex w-full justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6
                                ${isPending ? "bg-gray-200" : "bg-indigo-600 text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"}`}
                            >
                                {isPending ? "Connexion en cours..." : "Se connecter"}
                            </button>
                        </div>
                    </Form>
                </div>
                
            </div>
        </div>
    );
};

export default SignInPage;
